// src/components/album/AlbumFormInput.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Input, Textarea } from '@chakra-ui/react';

const AlbumFormInput = ({ 
  value, 
  onChange, 
  isTextarea = false,
  ...props 
}) => {
  const [localValue, setLocalValue] = useState(value || '');
  const inputRef = useRef(null);
  const cursorPositionRef = useRef(null);

  // Sincroniza com o valor externo apenas quando ele muda externamente
  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || '');
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    
    // Salvar posição do cursor antes da mudança
    cursorPositionRef.current = e.target.selectionStart;
    
    // Atualizar valor local imediatamente
    setLocalValue(newValue);
  };

  // Restaurar posição do cursor após renderização
  useEffect(() => {
    if (inputRef.current && cursorPositionRef.current !== null) {
      inputRef.current.setSelectionRange(
        cursorPositionRef.current,
        cursorPositionRef.current
      );
      cursorPositionRef.current = null;
    }
  });

  const handleBlur = () => {
    // Sincronizar com o estado pai apenas quando sair do campo
    if (onChange && localValue !== value) {
      onChange(localValue);
    }
  };

  const InputComponent = isTextarea ? Textarea : Input;

  return (
    <InputComponent
      ref={inputRef}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    />
  );
};

export default AlbumFormInput;